<template>
  <div>
    <v-form ref="contactsForm">
      <v-container fluid class="pa-0 pl-2">
        <v-row>
          <v-col cols="12" md="2" lg="2">
            <v-btn color="primary" class="mt-1" @click="addNewAddress">{{ $t('message.common.addNew') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-progress-linear v-if="loadingAddress" indeterminate color="primary"></v-progress-linear>
    <template>
      <v-container fluid class="pa-1">
        <v-simple-table dense class="elevation-1 bordered--table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" v-for="(head, index) in addressHeaders" :key="index">
                  {{ head.text }}
                </th>
                <th>{{ $t('message.mailConfiguration.action') }}</th>
              </tr>
            </thead>
            <tbody v-if="listOfAddress && listOfAddress.length > 0">
              <tr v-for="item in listOfAddress" :key="item.id">
                <td>{{ getCombinedAddress(item) }}</td>
                <td>{{ item.countryname }}</td>
                <td>{{ getaddressType(item.type) }}</td>
                <td>{{ getCoordinates(item) }}</td>
                <td>
                  <v-icon class="font--style"> {{ item.isstandard ? 'done' : 'clear' }} </v-icon>
                </td>
                <td>
                  <v-btn icon color="success" @click="editAddressHandler(item.id)">
                    <v-icon>colorize</v-icon>
                  </v-btn>
                  <v-btn icon color="error" @click="deleteAddressHandler(item.id)">
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </template>
    <v-dialog v-model="addressDialog" width="800" persistent>
      <form-data :references.sync="addressReference" :model="addressModel" ref="addressReference">
        <!-- <template slot="combo">
          <v-combobox :label="$t('message.customer.city')" hide-details outlined dense v-model="addressModel.city" :loading="isLoading"
            :items="cityList" item-text='city'>
          </v-combobox>
        </template> -->
      </form-data>
    </v-dialog>
  </div>
</template>
<script>
import FormTemplate from '@/components/FormTemplate'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      customerId: this.$route.params.crm_id,
      addressDialog: false,
      addressModel: {},
      listOfAddress: [],
      addressLoading: false,
      loadingAddress: false,
      isLoading: false,
      cityList: [],
      search: ''
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    addressHeaders () {
      return [{
        text: this.$t('message.customer.address'),
        value: 'address'
      }, {
        text: this.$t('message.customer.country'),
        value: 'countryname'
      }, {
        text: `${this.$t('message.customer.addressType')}`,
        value: 'type'
      }, {
        text: this.$t('message.customer.coordinates'),
        value: 'coordinates'
      }, {
        text: this.$t('message.customer.standard'),
        value: 'isstandard',
        isBoolean: true,
        sortable: false
      }]
    },
    addressReference () {
      return {
        title: this.addressModel.id ? this.$t('message.customer.updateAddress') : this.$t('message.customer.addAddress'),
        properties: [{
          model: 'address',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.address'),
          class: 'lg6 sm6'
        }, {
          model: 'address2',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: `${this.$t('message.customer.address')} 2`,
          class: 'lg6 sm6'
        }, {
          model: 'postbox',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.postbox'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'postcode',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          change: () => this.loadAllCityByPost(),
          label: this.$t('message.customer.postCode'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'city',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          loading: this.isLoading,
          label: this.$t('message.customer.city'),
          class: 'lg3 md4 sm6'
        },
        // {
        //   type: this.FORM_TYPE.COMBOBOX,
        //   class: 'lg3 md4 sm6',
        //   iscustomer: true
        // },
        {
          model: 'countryname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.country'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'latitude',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.latitude'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'longitude',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.longitude'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'type',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.product.type'),
          items: this.$_listOfAddressTypes,
          select_text: 'title',
          select_value: 'value',
          class: 'lg6 md4 sm6'
        }, {
          model: 'notes',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.common.note'),
          class: 'lg9 md9 sm8'
        }, {
          model: 'isstandard',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg3 md3 sm4 pt-2',
          label: this.$t('message.customer.isStandard')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.addressModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateAddressHandler(),
          loading: this.addressLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: () => this.closeAddNewAddress(),
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  mounted () {
    this.getAllAddressHandler()
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'customeraddresses') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteSuccess') })
        this.$store.commit('hideDialog')
        this.getAllAddressHandler()
      }
    })
  },
  methods: {
    addNewAddress () {
      this.addressDialog = true
      this.addressModel = { isstandard: true, type: 'delivery' }
    },
    closeAddNewAddress () {
      this.addressDialog = false
      this.addressLoading = false
      this.addressModel.id = undefined
      this.$refs.addressReference.$refs.validateForm.reset()
    },
    getAllAddressHandler () {
      this.loadingAddress = true
      let query = { 'filter': `customer_id eq ${this.customerId}` }
      this.$_executeApi('post', `customeraddresses/query`, query)
        .then((response) => {
          this.listOfAddress = response.data
        })
        .finally(() => {
          this.loadingAddress = false
        })
    },
    editAddressHandler (id) {
      this.$_executeApi('get', `customeraddresses/${id}`)
        .then((response) => {
          let model = response.data
          this.addressModel = model
          this.addressDialog = true
        })
    },
    saveUpdateAddressHandler () {
      if (this.$refs.addressReference.$refs.validateForm.validate()) {
        this.addressLoading = true
        let model = this.addressModel
        model.customer_id = this.customerId
        this.$_saveUpdateHandler('customeraddresses', model)
          .then((response) => {
            this.closeAddNewAddress()
            this.getAllAddressHandler()
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteAddressHandler (id) {
      let ids = [id]
      let payload = { ids, url: `customeraddresses/delete_multiple`, module: 'customeraddresses' }
      this.$store.commit('showDeleteDialog', payload)
    },
    getCoordinates (obj) {
      let coordinates = (({ latitude, longitude }) => ({ latitude, longitude }))(obj)
      return this.getCommaStringFromObj(coordinates)
    },
    getCommaStringFromObj (obj) {
      Object.keys(obj).forEach(key => !obj[key] && delete obj[key])
      return Object.values(obj).join(', ')
    },
    getCombinedAddress (obj) {
      let address = `${obj.address || ''} ${obj.address2 || ''}`
      let postal = `${obj.postcode || ''} ${obj.city || ''}`
      return address ? address + ', ' + (postal || '') : (postal || '')
    },
    getaddressType (type) {
      if (type) {
        return this.$t(`message.customer['${type}']`)
      }
    },
    // Search from city API
    loadAllCityByPost () {
      if (this.addressModel.postcode) {
        this.isLoading = true
        const key = process.env.VUE_APP_LOOKUP_CITY_KEY.toString()
        // const user = process.env.VUE_APP_LOOKUP_CITY_USER.toString()
        const options = {
          method: 'GET',
          headers: {
            'X-Mybring-API-Key': key,
            'X-MyBring-API-Uid': 'vitali@avalia.no'
          }
        }

        fetch(`${process.env.VUE_APP_LOOKUP_CITY_URL}${this.addressModel.postcode || ''}.json`, options)
          .then(response => response.json())
          .then(response => {
            const { postalCode } = response
            this.cityList = []
            const cityValues = []
            if (postalCode) {
              postalCode.map(x => {
                cityValues.push(x.city)
              })
            }
            this.cityList = cityValues
            if (cityValues && cityValues.length === 1) {
              this.addressModel.city = cityValues[0]
            } else {
              this.addressModel.city = ''
            }
            this.isLoading = false
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
